import { Component, OnInit } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, DateService } from 'app/services';
import { datetimeFormat } from 'app/constants/date-time-format';

import { orderBy } from 'lodash';

@Component({
  selector: 'app-carfax-vehicle-history',
  templateUrl: './carfax-vehicle-history.component.html',
  styleUrls: ['./carfax-vehicle-history.component.scss'],
})
export class CarfaxVehicleHistoryComponent implements OnInit {
  vehicleId: string = '';
  vehicle: any = {};
  serviceHistory: any[] = [];
  serviceRecalls: any[] = [];
  selectedTab: number = 0;
  sortOrder: boolean = false;
  sortField: string = '';
  isSync: boolean = true;
  internalVehicleName: string = '';
  carfaxVehicleName: string = '';
  hasConflicts: boolean = false;
  odometerUnit: string = '';

  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService,
    private dateService: DateService
  ) {}

  ngOnInit() {
    this.vehicleId = this.dynamicDialogConfig.data.vehicleId;

    if (this.vehicleId) {
      this.getVehicleHistory();
    }
  }

  handleSort(field: string) {
    this.sortOrder = !this.sortOrder;
    this.sortField = field;

    if (this.selectedTab === 0) {
      this.serviceHistory = orderBy(
        this.serviceHistory,
        [field],
        [this.sortOrder ? 'asc' : 'desc']
      );
    } else {
      this.serviceRecalls = orderBy(
        this.serviceRecalls,
        [field],
        [this.sortOrder ? 'asc' : 'desc']
      );
    }
  }

  getVehicleHistory() {
    this.httpService.getVehicleCarfaxHistory(this.vehicleId).then(
      (res) => {
        if (res && res.vehicle) {
          this.vehicle = res.vehicle;
          const { year = '', make = '', model = '' } = res.vehicle;
          this.internalVehicleName = `${year} ${make} ${model}`;
          this.odometerUnit =
            this.vehicle.mileageUnit === 'km' ? 'Km' : 'miles';
        }

        if (
          this.vehicle.isMotorConnected &&
          this.vehicle.isMotorAndCarfaxSynced
        ) {
          this.isSync = false;
        }

        if (res && res.serviceHistory) {
          if (res.serviceHistory) {
            const { year = '', make = '', model = '' } = res.serviceHistory;
            this.carfaxVehicleName = `${year} ${make} ${model}`;
            this.hasConflicts = !new RegExp(
              `^${this.helperService.trimString(this.internalVehicleName)}$`,
              'i'
            ).test(this.carfaxVehicleName);
          }

          if (res.serviceHistory.displayRecords) {
            res.serviceHistory.displayRecords.forEach((record: any) => {
              const { type, displayDate, odometer, text } = record;
              const serivce = {
                odometer,
                description: text.join(', '),
                datetime: new Date(displayDate).getTime(),
                date: this.dateService.formatDate(
                  new Date(displayDate),
                  datetimeFormat.mmmdyyyy
                ),
              };

              if (type === 'service') {
                this.serviceHistory.push(serivce);
                this.handleSort('datetime');
              } else if (type === 'recall') {
                this.serviceRecalls.push(serivce);
              }
            });
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  handleTabChange(selectedTab: number) {
    if (selectedTab !== this.selectedTab) {
      this.sortOrder = false;
      this.sortField = '';
    }

    this.selectedTab = selectedTab;
  }

  handleClose() {
    this.dynamicDialogRef.close({
      isSuccess: false,
    });
  }
}
